(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-accordion"] && !Shopify.designMode) return;
  try {
    
  class ProductDetailsAccordion {
    constructor() {
      this.init();
      this.initVideo();
    }

    initVideo() {
      // Debug video rendering
      const video = document.querySelector('.product-video');
      if (video) {
        console.log('Video element found:', video);
        console.log('Video src:', video.querySelector('source')?.src);
        console.log('Video poster:', video.poster);
        
        video.addEventListener('loadeddata', () => {
          console.log('Video loaded successfully');
        });
        
        video.addEventListener('error', (e) => {
          console.error('Video error:', e);
        });
      } else {
        console.log('No video element found');
      }
    }

    init() {
      const accordionItems = document.querySelectorAll('.product-detail-item');
      
      accordionItems.forEach(item => {
        const header = item.querySelector('.product-detail-item__header');
        const toggle = item.querySelector('.product-detail-item__toggle');
        
        if (header && toggle) {
          header.addEventListener('click', () => this.toggleItem(item));
          toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleItem(item);
          });
        }
      });
    }

    toggleItem(item) {
      const isOpen = item.classList.contains('is-open');
      
      // Close all other items
      document.querySelectorAll('.product-detail-item').forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
        }
      });
      
      // Toggle current item
      if (isOpen) {
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductDetailsAccordion());
  } else {
    new ProductDetailsAccordion();
  }

  } catch(e) { console.error(e); }
})();
})();
